import {
  SET_HERO_HEIGHT,
  SET_MODIFY_INTAKE_HEIGHT,
  SET_INTAKE_HEIGHT,
  SET_INTAKE_HISTORY_HEIGHT,
} from "../actions/actionTypes";

const initialState = {
  hero_height: 0,
  modifyIntake_height: 0,
  intake_height: 0,
  intakeHistory_height: 0,
};

const heightReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HERO_HEIGHT:
      return { ...state, hero_height: action.payload };
    case SET_MODIFY_INTAKE_HEIGHT:
      return { ...state, modifyIntake_height: action.payload };
    case SET_INTAKE_HEIGHT: {
      return { ...state, intake_height: action.payload };
    }
    case SET_INTAKE_HISTORY_HEIGHT: {
      return { ...state, intakeHistory_height: action.payload };
    }
    default:
      return state;
  }
};

export default heightReducer;
